import React, { useState } from 'react';
import {
  Typography,
  Button,
  Popover
} from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';
import { string, func, bool } from 'prop-types';
import { AccessoryPropsShape, tpCabTypes } from './types';
import { CabinetDrawer } from '../../CabinetVisualizer/Walls/CabinetDrawer';
import { useCabinetVisualizerDigitalDataStore } from '../../../../store';
import { CABINET_VISUALIZER_DIGITAL_DATA } from '../../../../constants';

export const RecommendedAcc = ({
  className, accessory, handleQuickView, isMobile, designId
}) => {

  const anchorRef = React.useRef(null);
  const {
    name, info, showAdd, tooltipTitle, tooltipContent, tooltipImage
  } = accessory;
  const [openInfo, setOpenInfo] = useState(false);
  const [openAddAcc, setOpenAddAcc] = useState(false);
  const [accessoryData, setaccessoryData] = useState(null);

  const getTouchpointType = (accessoryName) => {
    switch (accessoryName) {
    case 'Cabinet Fillers':
      return tpCabTypes.Filler;
    case 'Moulding':
      return tpCabTypes.Moulding;
    case 'End Panels':
      return tpCabTypes.Panels;
    default:
      return null;
    }
  };
  const touchpoint = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
    isStart: true,
    type: getTouchpointType(name) || [],
  };

  const handleOpenInfo = () => setOpenInfo(true);
  const handleCloseInfo = () => setOpenInfo(false);
  const handleToggleInfo = () => setOpenInfo(!openInfo);

  const { trackChooseCabinetOverlayEvent } = useCabinetVisualizerDigitalDataStore();
  const handleOpenAcc = () => {
    setaccessoryData(accessory);
    trackChooseCabinetOverlayEvent({
      eventName: CABINET_VISUALIZER_DIGITAL_DATA.CONFIGURATOR.CHOOSE_CABINET
    });
    setOpenAddAcc(true);
  };

  const handleCloseAcc = () => setOpenAddAcc(false);

  return (
    <div data-component="recommended-acc" className={className}>
      <div className="sui-flex">
        <Typography variant="body-base">{name}</Typography>
        {info && (
          <>
            <Info
              color="info"
              ref={anchorRef}
              size="small"
              onClick={isMobile ? handleToggleInfo : undefined} // onClick only on mobile
              onMouseEnter={!isMobile ? handleOpenInfo : undefined} // onMouseEnter only on desktop
              onMouseLeave={!isMobile ? handleCloseInfo : undefined} // onMouseLeave only on desktop
            />
            <Popover
              open={openInfo}
              anchorEl={anchorRef.current}
              onClose={handleCloseInfo}
              placement="top"
              title={tooltipTitle}
            >
              <div
                className={isMobile ? 'mobile-tooltip-popover' : 'tooltip-popover'}
              >
                <img
                  src={tooltipImage}
                  alt="A row a cabinets with button to visit shop your space page"
                  className="tootip-hover"
                  width="200"
                  height="200"
                />

                <Typography variant="body-small" className="tooltip-content">
                  {tooltipContent}
                </Typography>
              </div>
            </Popover>
          </>
        )}
        {showAdd && (
          <>
            <Button variant="text" onClick={handleOpenAcc}>
              <Typography variant="body-xs">
                Add
              </Typography>
            </Button>
            {accessoryData && (
              <CabinetDrawer
                designId={designId}
                touchpoint={touchpoint}
                open={openAddAcc}
                onClose={handleCloseAcc}
                accessory={accessoryData}
                handleQuickView={handleQuickView}
              />
            )}

          </>
        )}
      </div>
    </div>
  );
};

RecommendedAcc.propTypes = {
  designId: string.isRequired,
  accessory: AccessoryPropsShape,
  className: string,
  handleQuickView: func.isRequired,
  isMobile: bool
};

RecommendedAcc.defaultProps = {
  accessory: {},
  className: undefined,
  isMobile: false
};